if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Căutăm coletul dumneavoastră...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Se caută…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "RO"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Prea multe încercări
            </div>

            <div class="ee-error-message">
                Ați efectuat prea multe căutări la rând. Așteptați un minut și încercați din nou.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Comanda a fost anulată
            </div>

            <div class="ee-error-message">
                Această comandă a fost anulată și nu va fi procesată.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Pregătim comanda dumneavoastră
                </div>

<div class="ee-info-message">


 <br>

    Comanda dumneavoastră a fost primită și este în curs de procesare.

    <br><br>

    Nu a fost încă atribuit un număr de urmărire. După ce coletul este expediat, informațiile de urmărire vor fi disponibile pe această pagină și prin e-mail.

    <br><br>

    Dacă aveți alte întrebări despre comanda dumneavoastră, contactați echipa noastră de asistență pentru clienți.

    <br>

                    <a href="https://euroelectronics.ro/pages/contact" class="ee-contact-link">
                        Contactați-ne
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Comanda nu a fost găsită
                </div>

                <div class="ee-error-message">
                    Nu am putut găsi nicio comandă care să corespundă numărului comenzii și adresei de e-mail furnizate. Verificați dacă datele au fost introduse corect și încercați din nou.
                    <br><br>

                    Dacă aveți nevoie de ajutor, contactați echipa noastră de asistență pentru clienți.
                    <br>

                    <a href="https://euroelectronics.ro/pages/contact" class="ee-contact-link">
                        Accesați formularul de contact
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Colet găsit
                        </div>
<div class="ee-result-description">
                            Mai jos găsiți informații despre coletul dumneavoastră. Faceți clic pe butonul de mai jos pentru a accesa direct urmărirea la transportator.
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Număr comandă
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Număr de urmărire
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Urmăriți coletul
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Produse comandate (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            A apărut o eroare
                        </div>

                        <p>
                            Nu ne-am putut conecta la sistemul de urmărire. Încercați din nou peste câteva momente.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}
